import { WinkEmojiDivider } from '@openeducation/oe-it-components';
import React from 'react';

import { BoxMessage } from '../../molecules/box-message/box-message';

export const ActiveClassCardEmpty = () => {
  return (
    <BoxMessage
      title="No active classes"
      divider={<WinkEmojiDivider />}
      width="100%"
      padding={0}
    />
  );
};
